const updateFavicon = (currentBase) => {
    console.log("Updating favicon for base:", currentBase);
    const link = document.querySelector("link[rel~='icon']");
    let iconPath;
    switch(currentBase) {
        case 'agip' :
            iconPath = '/favicons/agip.ico'
            break;
        case 'apeprev' : 
            iconPath = '/favicons/apeprev.ico'
            break;
        case 'semper' :
            iconPath = '/favicons/semper.ico'
            break;
    }
    if (link) {
        link.href = iconPath;
    } else {
        const newLink = document.createElement("link");
        newLink.rel = "icon";
        newLink.href = iconPath;
        document.head.appendChild(newLink);
    }
};

export default updateFavicon;
